export default __webpack_public_path__ + "static/media/Quiken_Correo-50.f831b3da.svg";